import React from "react";
import {Badge, CardBody, CardText, CardTitle} from "reactstrap";
import {FaCalendar, FaEnvelope, FaUserCircle} from "react-icons/fa";
import Gravatar from "react-gravatar";

export const UserCard = ({data}) => {
  const {
    first_name = "",
    last_name = "",
    email = "",
    username = "",
    date_joined = "",
    is_active = false,
  } = data;
  let name = `${first_name} ${last_name}`;

  return (
    <div style={{display: "flex", flex: "1 1 auto"}}>
      <div style={{display: "inline-block"}}>
        <Gravatar
          email={email}
          size={300}
          rating="pg"
          default="identicon"
          className="avatar avatar-lg"
          style={{margin: "10%"}}
        />
      </div>
      <CardBody>
        <CardTitle tag="h3">
          <CardText>
            <FaUserCircle aria-hidden="true" /> {name !== " " ? name : username}{" "}
            <Badge color="" className="badge-dot mr-4" data-cy={"card-is-active"}>
              {is_active ? <i className="bg-success" /> : <i className="bg-warning" />}
            </Badge>
          </CardText>
        </CardTitle>
        <CardText style={{display: "flex", alignItems: "baseline"}}>
          <FaEnvelope aria-hidden="true" />
          <span
            className="user__email"
            style={{
              marginLeft: "5px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              maxWidth: "15ch",
            }}
          >
            {" "}
            {email}
          </span>
        </CardText>
        <CardText>
          <small>
            <FaCalendar /> Joined {date_joined}
          </small>
        </CardText>
      </CardBody>
    </div>
  );
};
